import { AppShell } from '@mantine/core';
import { createDeleteDeviceDetailedModal } from 'features/delete-device';
import { createEditDeviceDetailedModal } from 'features/edit-device';
import { createDeviceRegistry } from 'entities/device';
import { devicesPageModel } from '../devices-page-model';
import cls from './devices-page.module.scss';

const DevicesRegistry = createDeviceRegistry(devicesPageModel.devicesRegistryModel);

const DeleteDeviceModal = createDeleteDeviceDetailedModal(devicesPageModel.deleteDeviceModel);

const EditDeviceModal = createEditDeviceDetailedModal(devicesPageModel.editDeviceModel);

export const DevicesPage = () => (
	<>
		<AppShell.Main className={cls.devicesPage}>
			<DevicesRegistry
				className={cls.devicesPageDevicesRegistry}
				tableTdActionSlot={(device) => (
					<div className={cls.devicesPageActions}>
						<EditDeviceModal.ActionIcon modalData={device} />
						<DeleteDeviceModal.ActionIcon modalData={device} />
					</div>
				)}
			/>
		</AppShell.Main>
		<DeleteDeviceModal />
		<EditDeviceModal />
	</>
);
